import React from 'react';
import PropertyManagementDisplay from '../properties/PropertyManagementDisplay';

export default function JobHomeDetails({ job, propertyManagers = [], handleCallManager }) {
  const propertyManagementTeam = job?.property?.propertyManagementTeam;

  return (
    <div className="bg-white shadow rounded-lg mb-3 lg:mb-6">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
          Home Information
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-gray-50 rounded-lg p-4 shadow-sm">
            <h4 className="text-base font-medium text-gray-900 mb-2">
              Home Info
            </h4>
            <p className="text-base text-gray-900">
              {(job.property.beds !== null && job.property.beds !== undefined) || 
               (job.property.baths !== null && job.property.baths !== undefined) ? (
                <>
                  {job.property.beds !== null && job.property.beds !== undefined && (
                    <><span className="font-medium">{parseFloat(job.property.beds).toFixed(job.property.beds % 1 === 0 ? 0 : 1)}</span> bed{parseFloat(job.property.beds) !== 1 ? 's' : ''} </>
                  )}
                  {job.property.beds !== null && job.property.beds !== undefined && 
                   job.property.baths !== null && job.property.baths !== undefined && (
                    <span>, </span>
                  )}
                  {job.property.baths !== null && job.property.baths !== undefined && (
                    <><span className="font-medium">{parseFloat(job.property.baths).toFixed(job.property.baths % 1 === 0 ? 0 : 1)}</span> bath{parseFloat(job.property.baths) !== 1 ? 's' : ''}</>
                  )}
                </>
              ) : (
                <span className="text-gray-500 italic">No home info available</span>
              )}
            </p>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-4 shadow-sm">
            <h4 className="text-base font-medium text-gray-900 mb-2">
              Property Management
            </h4>
            <PropertyManagementDisplay
              team={propertyManagementTeam}
              managers={propertyManagers}
              handleCallManager={handleCallManager}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
